export default "__VITE_ASSET__C8IhvrBL__"